import { ROUTES } from 'src/enums';

export default [
  {
    path: '/tube',
    meta: { auth: true, tube: true },
    component: () => import('layouts/SpaLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('layouts/TubeLayout.vue'),
        children: [
          {
            path: '',
            name: ROUTES.TUBE.INDEX,
            component: () => import('pages/tube/DashboardPage.vue'),
          },
          {
            path: 'outliers',
            name: ROUTES.TUBE.OUTLIERS,
            component: () => import('pages/tube/OutliersPage.vue'),
          },
          {
            path: 'keywords',
            name: ROUTES.TUBE.KEYWORDS,
            component: () => import('pages/tube/KeywordsPage.vue'),
          },
          {
            path: 'my-videos',
            name: ROUTES.TUBE.MY_VIDEOS,
            component: () => import('pages/tube/MyVideosPage.vue'),
          },
          {
            path: 'my-thumbnails',
            name: ROUTES.TUBE.MY_THUMBNAILS,
            component: () => import('pages/tube/MyThumbnailsPage.vue'),
          },
          {
            path: 'brand-voice',
            name: ROUTES.TUBE.BRAND_VOICE,
            component: () => import('pages/BrandVoicePage.vue'),
          },
        ],
      },
    ],
  },
];
